import { downloadOrOpenFileByFormat } from 'packages/common/utils/download';
import { openPdf } from 'packages/common/utils/file';
import reportCenterResource from '../../../resources';

export const mapRequestFilters = ({
  report,
  reportType,
  reportName,
  stocking,
  jobDescription,
  worker,
  dateMonthPeriod,
  dateYearPeriod,
  description,
  datePeriod,
  event,
  orderBy,
  groupBy,
  collaboratorType,
}) => {
  return {
    relatorioNome: reportName,
    relatorio: report,
    formato: reportType,
    periodo: dateMonthPeriod,
    ordem: orderBy,
    descricao: description,
    quebra: groupBy,
    idLotacao: stocking,
    idFuncao: jobDescription,
    idFuncionario: worker === '0' ? null : worker,
    collaboratorType,
    ano: dateYearPeriod,
    eventos: event,
    data: datePeriod,
  };
};

export const mapRequestProvisionFilters = ({ report, reportName, dateMonthPeriod }) => ({
  report,
  reportName,
  competence: dateMonthPeriod,
});

export const getReport = params => reportCenterResource.getReport(params)
  .then(response =>
    downloadOrOpenFileByFormat({
      response,
      reportName: `${params.relatorioNome}.${params.formato}`,
    }));

export const getProvisionReport = params => reportCenterResource.getProvisionReport(params)
  .then(({ data }) => openPdf(data));

export const getPayrollPersonReport = body => reportCenterResource.getPayrollPersonReport(body)
  .then(({ data }) => openPdf(data));

export const getPayrollReport = body => reportCenterResource.getPayrollReport(body)
  .then(({ data }) => openPdf(data));
